import { Section } from "./section";

export class City {
    cityId: number;
    cityTitle: string;
    section: Section;

    constructor() {
        this.section = new Section();
    }
}


